import React, { useEffect, useState } from "react";
import classNames from "classnames";
import constants from "../../../../../globalization";
import classes from "./CheckDetails.module.css";
import CommonUtil from "../../../common";
import UTIL from "../../../../../util";

const FireboardTip = (props) => {
  const {
    selectedItem,
    currency = '$',
    suppressTipsOnFireBoard,
    bottomContainerStyle,
  } = props || {};
  const [successTickets, setSuccessTickets] = useState([]);

  useEffect(() => {
    const { tickets } = selectedItem || {};
    if (Array.isArray(tickets) && tickets.length)
      setSuccessTickets(tickets.filter(t => t.ticketStatusId === 1 && t.ticketTypeId === 1));
    else
      setSuccessTickets([]);
  }, [selectedItem]);

  const { selectedCheckDetails = {} } = selectedItem || {};

  const getTipPercent = () => {
    const { tipAmount, subTotalAmount } = selectedCheckDetails;
    let tipPercent = 0;
    if (tipAmount !== 0 && subTotalAmount !== 0) {
      tipPercent = tipAmount / subTotalAmount;
    }
    return tipPercent ? `(${(tipPercent * 100).toFixed(2)}%)` : '';
  };

  const itemsCount = CommonUtil.getItemCount(selectedCheckDetails.items);

  const getValue = field => {
    if (selectedCheckDetails[field]) {
      return `${currency}${selectedCheckDetails[field].toFixed(2)}`;
    }
    return '';
  };

  return (
    <div className={classNames({
      [`${classes.bottomContainer}`]: true,
      [`${bottomContainerStyle}`]: true,
      [`${classes.bottomContainerHeight}`]: successTickets.length > 0
    })}>
      <div className={classes.toolTipContainer}>
        <AmountDetail label={constants.tipSubTotal.toUpperCase()} value={getValue('subTotalAmount')} flexBasis={'50%'} />
        <AmountDetail label={`${constants.taxLabel}:`} value={getValue('taxAmount')} flexBasis={'50%'} />
        <AmountDetail label={`${constants.discount}:`} value={getValue('discountAmount')} flexBasis={'50%'} />
        <AmountDetail label={`${constants.SvcChg}:`} value={getValue('serviceChargeAmount')} flexBasis={'50%'} />
        <AmountDetail label={`${constants.total}:`} value={getValue('totalAmount')} flexBasis={'100%'} />
        <AmountDetail label={`${constants.checkHistoryPaid.toUpperCase()}:`} value={getValue('paidAmount')} flexBasis={'33.33%'} />
        {suppressTipsOnFireBoard
          ? null
          : <AmountDetail label={`${constants.fireboardTip}:`} value={`${getValue('tipAmount')} ${getTipPercent()}`} flexBasis={'33.33%'} />
        }
        <AmountDetail label={`${constants.checkHistoryUnpaid.toUpperCase()}:`} value={getValue('unpaidAmount')} flexBasis={'33.33%'} />
      </div>
      {successTickets.length > 0
        ? <PaymentMethods tickets={successTickets} currency={currency} />
        : null
      }
    </div>
  );
};

export default FireboardTip;

const AmountDetail = ({ label, value, flexBasis }) => {
  return (
    <div className={classes.tooltipItemContainer} style={{ flexBasis: flexBasis }}>
      <span className={classes.toolTipHeaderText}>{label}</span>
      <span className={classes.toolTipText}>{value}</span>
    </div>
  );
};

const PaymentMethods = ({ tickets, currency }) => {

  const getPaymentInfo = ticket => {
    return {
      paymentType: ticket.cardType ? UTIL.getCardName(ticket.cardType) : UTIL.getPaymentType(ticket.ticketPaymentTypeId),
      name: ticket.TicketPaymentTypeName === 'CreditCard' ? ticket.cardHolderName : '',
      cardNumber: ticket.redactedCardNumber ? ticket.redactedCardNumber.slice(-4) : '',
      amount: ticket.ticketAmount,
    };
  };

  return (
    <div className={classes.paymentInfoContainer}>
      {Array.isArray(tickets) &&
        tickets.map((ticket, index) => {
          const paymentInfo = getPaymentInfo(ticket);
          return (
            <div key={`index-${index}`} className={classes.paymentInfoWrapper}>
              <div className={classes.paymentText}>{paymentInfo.paymentType}</div>
              <div className={classes.paymentText}>{paymentInfo.name}</div>
              <div className={classes.paymentText}>{paymentInfo.cardNumber}</div>
              <div className={classes.paymentText}>{currency}{paymentInfo.amount}</div>
            </div>
          )
        }
        )}
    </div>
  );
};
